import React, { useEffect, useLayoutEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import FirstBox from "../../components/FirstBox";
import SecondBox from "../../components/SecondBox";
import ThirdBox from "../../components/ThirdBox";
import Top from "../../components/Top";
import ForthBox from "../../components/ForthBox";
import RecentBlogs from "../../components/RecentBlogs/RecentBlogs";

gsap.registerPlugin(ScrollTrigger);
gsap.defaults({ ease: "ease", duration: 2 });

const Landing = () => {
  const [showImage, setShowImage] = useState(true);

  useLayoutEffect(() => {
    let mm = gsap.matchMedia();
    mm.add("(min-width:1100px)", () => {
      const tl = gsap.timeline();

      tl.from(".first", { xPercent: -100, duration: 0.1, ease: "linear" })
        .from(".second", { xPercent: 100, duration: 0.2, ease: "linear" })
        .from(".third", { yPercent: -100, duration: 0.4, ease: "linear" })
        .from(".forth", { yPercent: 100, duration: 0.5, ease: "linear" });

      // const ctx = gsap.context(() => {
      //  gsap.to(".box-a",{
      //   scrollTrigger: {
      //   trigger: '.box-a',
      //   pin: true,
      //   start: '20px 10%',
      //   end: '+=500',
      //   markers: true,
      //   scrub:true
      //  },
      //  x: 400,
      //  rotation:360,
      //  duration:3
      // })

      ScrollTrigger.create({
        animation: tl,
        trigger: "#container",
        pin: true,
        scrub: 2,
        start: "top top",
        end: () => "+=" + parseInt(document.querySelector(".end").offsetHeight),
        // end: "top bottom",
        // onUpdate: (self) => {console.log(self)},
        markers: false,
        // anticipatePin: 1,
      });
    });
  }, []);

  return (
    <>
      <Top />
      <div className="container" id="container">
        <FirstBox />
        <SecondBox />
        <ThirdBox />
        <ForthBox />
        <RecentBlogs />
      </div>

      <div className="end" id="end"></div>
    </>
  );
};

export default Landing;
